import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import {
  MultiChatSocket,
  ChatFeed,
  useSingleChatLogic,
} from "react-chat-engine-advanced";
import "./styles.css";

const Chat = () => {
  const {
    REACT_APP_CHAT_ENGINE_PROJECT_ID,
    REACT_APP_USER_SECRET,
    REACT_APP_USER_NAME,
    REACT_APP_CHAT_ID,
  } = process.env;

  const chatProps2 = useSingleChatLogic(
    REACT_APP_CHAT_ENGINE_PROJECT_ID,
    REACT_APP_CHAT_ID,
    REACT_APP_USER_SECRET
  );

  const [isChatOpen, setChatState] = useState(false);

  const chatButtonText = isChatOpen ? "Close Chat" : "Open Chat";
  const hideStyleIfClosed = isChatOpen ? {} : { display: "none" };

  return (
    <>
      <ChatFeed
        {...chatProps2}
        username={REACT_APP_USER_NAME}
        style={{ ...hideStyleIfClosed }}
      />
      {/* 4. SOCKET */}

      <div className={`chat-button ${isChatOpen ? "chat-is-open" : ""}`}>
        <Button onClick={() => setChatState(!isChatOpen)}>
          {chatButtonText}
        </Button>
      </div>
      <MultiChatSocket {...chatProps2} />
    </>
  );
};

export default Chat;
